import { useAuthContext } from '@/auth/useAuthContext';
import { hiddenModulesOf } from '@/layouts/main/mega-menu/hiddenModules';

/** Modules the user's firm has hidden (OL-135); Company Settings refreshes the list on save. */
export const useHiddenModules = () => {
  const { auth } = useAuthContext();
  const hidden = hiddenModulesOf(auth?.user);

  return { hidden, isHidden: (key) => hidden.includes(key) };
};
